import * as Yup from 'yup'
import { isEqual } from 'lodash'

import { APP_COLORS } from '../../../helpers/constants'

export const saltoSpaceDropdownStyles = (hasError) => ({
  control: () => ({
    display: 'flex',
    minHeight: '5vh',
    backgroundColor: hasError ? APP_COLORS.red100 : APP_COLORS.grey200,
    justifyContent: 'space-between',
    border: hasError ? `1px solid ${APP_COLORS.red200}` : `1px solid ${APP_COLORS.grey800}`,
    borderRadius: '5px',
    alignItems: 'center',
    cursor: 'pointer',
    overflow: 'hidden',
  }),
  option: (_, state) => ({
    backgroundColor: state.isSelected ? APP_COLORS.grey300 : APP_COLORS.baseWhite,
    flexDirection: 'row',
    display: 'flex',
    height: '5vh',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: '1vw',
    fontSize: '14px',
    cursor: 'pointer',
    borderBottom: `1px solid ${APP_COLORS.grey300}`,
  }),
  valueContainer: (styles) => ({
    ...styles,
    maxHeight: '10vh',
    overflowY: 'auto',
  }),
})

export const defaultDropdownStyles = () => ({
  control: () => ({
    display: 'flex',
    minHeight: '5vh',
    backgroundColor: APP_COLORS.grey200,
    justifyContent: 'space-between',
    border: `1px solid ${APP_COLORS.grey800}`,
    borderRadius: '5px',
    alignItems: 'center',
    cursor: 'pointer',
    overflow: 'hidden',
  }),
  option: (_, state) => ({
    backgroundColor: state.isSelected ? APP_COLORS.grey300 : APP_COLORS.baseWhite,
    flexDirection: 'row',
    display: 'flex',
    height: '5vh',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: '1vw',
    fontSize: '14px',
    cursor: 'pointer',
    borderBottom: `1px solid ${APP_COLORS.grey300}`,
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 9,
    maxHeight: '140px',
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: '140px',
  }),
  container: (styles) => ({
    ...styles,
    width: '100%',
  }),
  valueContainer: (styles) => ({
    ...styles,
    maxHeight: '115px',
    overflowY: 'auto',
  }),
  singleValue: (provided) => {
    const transition = 'opacity 300ms'
    return { ...provided, transition }
  },
  placeholder: (styles) => ({
    ...styles,
    fontSize: '1em',
    color: '#8d8c8c',
    textAlign: 'center',
    fontWeight: '400',
  }),
})

export const getSelectedItemsValue = (selectedIds, itemsArray) => {
  return selectedIds
    ? selectedIds.map((id) => itemsArray.find((item) => item.saltoId === id))
    : null
}

const getAccessText = (selectedGroupsNames, selectedAccessLevelsNames) => {
  if (selectedGroupsNames.length === 0 && selectedAccessLevelsNames.length === 0) {
    return ' '
  }

  const arraysAreEqual = isEqual(selectedGroupsNames, selectedAccessLevelsNames)

  if (arraysAreEqual) {
    return ` to ${selectedGroupsNames.join(', ')} `
  }

  const groupsText = selectedGroupsNames.join(', ')
  const accessLevelsText =
    selectedAccessLevelsNames.length > 0 ? ` and ${selectedAccessLevelsNames.join(', ')}` : ''
  return ` to ${groupsText}${accessLevelsText} `
}

export const getConfirmationText = (t, clientData, values) => {
  const {
    user: { firstName, lastName },
    apartment,
  } = clientData

  const accessText = getAccessText(values.selectedGroupsNames, values.selectedAccessLevelsNames)

  return t('clients-legacy:profileView.integrations.confirmAccessBody', {
    accessText,
    apartment,
    firstName,
    lastName,
  })
}

export const getDisconnectConfirmationText = (clientData) => {
  const {
    user: { firstName, lastName, email },
    apartment,
  } = clientData

  const residentName = [firstName, lastName].filter(Boolean).join(' ') || email

  return `This action will remove access for ${residentName}, resident of Unit ${apartment}, and remove it from Salto Space. Do you wish to proceed?`
}

export const displayUserFullName = (user) => {
  if (!user) return '-'
  return `${user.firstName} ${user.lastName}`
}

export const getValidationSchema = (t) =>
  Yup.object().shape({
    guestCount: Yup.number()
      .required(t('clients-legacy:profileView.visits.guestCountRequiredError'))
      .min(0, t('clients-legacy:visitCreate.guestCountNegativeError')),
    householdMembersIds: Yup.array().of(Yup.string()),
  })
